import React from 'react'
import Papa from 'papaparse'
import { Button, Form, Label, Modal, Checkbox, Grid, Progress, Header} from "semantic-ui-react";
import { connect, useDispatch, useSelector} from "react-redux";
import { useLocation } from 'react-router-dom';

import {socket} from "../../../lib/socketio";
import {setPPID} from "../../../actions/headerActions";
import { setCurrentPLC } from '../../../actions/headerActions';

// @test 250214, retune load update
import _ from 'lodash';
import {createUserLog} from "../../../lib/api";

const Retune_PSM4 = ({ppid}) => {

  const [open, setOpen] = React.useState(false);
  const [buttonClickType, setButtonClickType] = React.useState({'buttonClick': ''});
  const [tagData, setTagData] = React.useState();
  const [loadFilePath, setLoadFilePath] = React.useState('');
  const [saveFilePath, setSaveFilePath] = React.useState('');
  const [loadObjectToSend, setLoadObjectToSend] = React.useState([]);
  const [loadComplete, setLoadComplete] = React.useState(0);
  const [loadObject, setLoadObject] = React.useState();
  const [isCsvDone, setIsCsvDone] = React.useState(false);

  // update 240315 by sumin, display each load/save status
  const [isSaveReady, setIsSaveReady] = React.useState(0);
  const [isLoadReady, setIsLoadReady] = React.useState(0);

  // update Compare File
  const [secondModalOpen, setSecondModalOpen] = React.useState(false);
  const [compareFilePath, setCompareFilePath] = React.useState('');
  const [compareData, setCompareData] = React.useState('');
  const [defaultFilePath, setDefaultFilePath] = React.useState('');
  const [defaultData, setDefaultData] = React.useState('');
  const [resultData, setResultData] = React.useState({});
  const [checked, setChecked] = React.useState(false);
  const [diffData, setDiffData] = React.useState([]);
  const [deleteClick, setDeleteClick] = React.useState(false);
  // const [diffData, setDiffData] = React.useState([]);
  const fileReader = new FileReader();
  const defaultFileReader = new FileReader();

  // update 240516 by sumin, Load file err msg
  const [loadFileErr, setLoadFileErr] = React.useState(0);
  var loadFilePPC = '';

  const [progress, setProgress] = React.useState(0);

  // update 250131, send load file name to log
  // @ TEST 250214, retune load update
  // 0 default, 1 before save 2 after save
  const [loadTagData, setloadTagData] = React.useState({}); // load data
  const [loadResultTagData, setloadResultTagData] = React.useState({}); // load result
  const [autoLoadStatus, setAutoLoadStatus] = React.useState(0); // 0 : innitial, 1 : loadCompare , 2 : loadCompare complete, 3 : fail
  const [reloadTagData, setReloadTagData] = React.useState({});
  const [DisplayLoadResultTag, setDisplayLoadResultTag] = React.useState([]);
  const [isAfterLoad, setIsAfterLoad] = React.useState(false);

  const location = useLocation();
  const currentPLC = useSelector(state => state.header.currentPLC);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.nav.user);
  const electronApp = useSelector((state) => state.nav.electronApp);

  // update change PSM
  const [isPrefixChanged, setIsPrefixChanged] = React.useState(false);

  const FILE_ERROR = {
    NONE : 0,
    INVALID_FILE : 1,
    INVALID_PSM : 2
  };

  const ERROR_MESSAGES = {
    [FILE_ERROR.INVALID_FILE]: 'INVALID FILE',
    [FILE_ERROR.INVALID_PSM]: 'INVALID PSM'
  };

  React.useEffect(()=> {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  // retune progress bar
  React.useEffect(()=> {
    if(Object.values(loadFilePath).length > 0){
      socket.on('retune count', (value) => {
        setProgress(parseInt((value.result.count / ((Object.values(loadObjectToSend).length / 30) -1)) * 100));
      })
    };
  });

  const saveCurrentData = (data) => {
    setIsSaveReady(2);
    setIsAfterLoad(false);
    if(isLoadReady === 3){
      setloadResultTagData(data);
    }
  }

  React.useEffect(() => {
    if (buttonClickType.buttonClick !== '') {
      if (buttonClickType.buttonClick === 'Retune Save PSM4') {
        socket.emit('button click', {'buttonClickType': 'Retune Save PSM4'});
        socket.on('receive retune values', (value) => {
          setTagData(value.result);
        });
        setIsSaveReady(1);
        if (!electronApp) {
          let log = {
            user_id: user.id,
            powerplant_id: ppid,
            display_id: null,
            datetime: new Date().toISOString(),
            data: JSON.stringify({ type: "Retune Save" }),
          };
          createUserLog({ log }).catch(console.error);
        }
      }

      if (buttonClickType.buttonClick === 'Retune Load') {
        setIsLoadReady(2);
        Papa.parse(loadObject, {
          header: false,
          download: true,
          skipEmptyLines: true,
          // Here this is also available. So we can call our custom class method
          complete: updateData
        });
      }

      // TODO : result compare test
      if(buttonClickType.buttonClick === 'Check Load Result'){
        socket.emit('button click', {'buttonClickType': 'Retune Save PSM4'});
        socket.on('receive retune values', (value) => {
          saveCurrentData(value.result);
        });
      }
    }

    return () => {
      socket.removeAllListeners();
    };
  }, [buttonClickType]);

  React.useEffect(() => {
    if (saveFilePath === '') {
      let fileName = "RetuneLog_PSM4_";
      const d = new Date();
      // const id = ppid.toString() + "_";
      const id = (typeof ppid !== 'undefined' && typeof ppid !== 'null'  ? ppid.toString() + "_" : "99999_");
      // const id = "ppid_"
      fileName += id;
      const datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + " " +
          d.getHours() + "-" + d.getMinutes();
      fileName += datestring.replace(/ /g, "_");
      setSaveFilePath(fileName);
    }
  }, [saveFilePath]);

  // [UPDATE] update specific values in object
  const updateConfigApplyTags = (obj, newValue) =>{
    for(let key in obj){
      if(key.endsWith('_APPLY')){
        obj[key] = newValue;
      }
    }
    return obj;
  }

  // file save- download logic
  React.useEffect(() => {
    if (typeof tagData !== 'undefined' && tagData !== null && isCsvDone === false) {

      // [UPDATE] 260512, Set All CONFIG_%_APPLY tag values to true when saving Retune
      let newTagData = updateConfigApplyTags(tagData, 1);
      setTagData(newTagData);

      const tags_names = Object.keys(tagData);
      const tag_values = Object.values(tagData);

      let csv = "";

      tags_names.forEach((tag_name_el, idx) => {
        let row = "";
        row += '"' + tag_name_el + '",';
        row += '"' + tag_values[idx] + '",';
        csv += row + '\r\n';
      });

      let uri = 'data:text/csv;charset=utf-8,' + escape(csv);
      let link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = saveFilePath + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsCsvDone(true);
      setIsSaveReady(2); // save complete
    }
    else if (typeof tagData !== 'undefined' && tagData !== null && isCsvDone === true){  // update 250415, test retune save without download 250415
      // TODO : need one more flag (after load flag)
      // setIsSaveReady(2);
      // setIsAfterLoad(false);
    }
  }, [tagData]);

  // update 250325, retune load update : after load parameters, save data
  // TODO : 2026, load compare 제대로 되는지 테스트, deps에 tagData 추가함
  // React.useEffect(() => {
  //     if( isSaveReady === 2 && isLoadReady === 3 ){ // if save complete, load ready save data to loadResultTagData
  //         setloadResultTagData(tagData);
  //     }
  // }, [isSaveReady]);

  // update 250325, retune load update : run autoCompare function
  React.useEffect(() => {
    if( loadResultTagData && Object.keys(loadResultTagData).length > 0 ){ // after save data (loadresultTagData) run autoComapre function
      // setDisplayLoadResultTag([]);
      autoCompare(loadTagData, loadResultTagData); // loadTagData : load file value, loadResultTagData : load result data
    }
  }, [loadResultTagData]);

  // @ TEST 250220, retune load update : loadObjectToSend format to obejctFormat
  // update 250325, retune load update : to compare, data type converting - object arr to object
  const objArrToObj = (objArr) => {
    let temp = {};
    objArr.forEach(el => {
      temp[el['tag_name']] = parseFloat(el['tag_value']);
    })

    if(Object.keys(temp).length > 0){
      setloadTagData(temp);
    }
  }

  React.useEffect(() => {
    if (loadComplete === 1) { // load ing...
      socket.emit('button click', {'buttonClickType': 'Retune Load', 'tags': loadObjectToSend}); // send tag object to server (in loadObjectToSend)
      objArrToObj(loadObjectToSend);

      socket.on('retune ready', (value) => {
        setIsLoadReady(value.result.ready);
        setLoadComplete(0);
        // update 250131 send load file name to log
        // setLoadFileName('');
        // setLoadFilePath('');
        // setIsLoadReady(3);
        if (!electronApp) {
          let log = {
            user_id: user.id,
            powerplant_id: ppid,
            display_id: null,
            datetime: new Date().toISOString(),
            data: JSON.stringify({ type: "Retune Load" }),
          };
          createUserLog({ log }).catch(console.error);
        }
      });
    };

    return () => {
      socket.removeAllListeners();
    };
  }, [loadComplete]);

  // @ TEST 250226, retune load update
  // update 250325, retune load update : after load completed, run autoRetuneSave
  React.useEffect(() => {
    async function loadReady(){
      if(isLoadReady === 3){
        setLoadObjectToSend([]);
        autoRetuneSave();
      }
    }
    loadReady();
  }, [isLoadReady]);

  // update 240411 by sumin, bugfix - reset loadObjectToSend
  // @ TEST -> need to check
  // React.useEffect(() => {
  //     console.log(loadObjectToSend);
  //     if(isLoadReady === 3){
  //         setLoadObjectToSend([]);
  //     }
  // }, [isLoadReady]);

  // load update code
  const updateData = (result) => {
    result.data.forEach(rowEl => {
      if(rowEl[0].startsWith('PSM4_')){
        var temp = {'tag_name': rowEl[0], 'tag_value': rowEl[1]};
        loadObjectToSend.push(temp);
      }else if(rowEl[0].startsWith('PSM') && !rowEl[0].startsWith('PSM4_') && isPrefixChanged && loadFileErr === 2){ //
        let prefix = currentPLC;
        var temp = {'tag_name': prefix + rowEl[0].substring(4), 'tag_value' : rowEl[1]};
        loadObjectToSend.push(temp);
        setIsPrefixChanged(false);
      }
    });
    setLoadComplete(1); // useEffect(goes to load complete)
  };

  // Object array [{tag_name: 'tagName', 'tag_value': 'value'}]
  // auto load with out file upload
  // update 250325, retune load update : load parameters after compare
  const autoLoadupdateData = (obj) => {
    if(DisplayLoadResultTag && DisplayLoadResultTag.length > 0){
      setDisplayLoadResultTag([]);
    }

    setAutoLoadStatus(3);   // display modal status : loading....
    setIsLoadReady(2);      // display load progress : loading...

    setloadTagData(obj);    // save difference data

    // data type converting to load parameters
    Object.keys(obj).forEach(el => {
      if(el.startsWith('PSM4_')){
        var temp = {'tag_name' : el, 'tag_value': obj[el].toString()};
        loadObjectToSend.push(temp);
      }
    })
    setLoadComplete(1);
  }

  const handleOpen = () => {
    setOpen(true);
    setIsSaveReady(0);
    setIsLoadReady(0);
    setLoadFilePath('');
    setCompareFilePath('');

    // update 250227, initialize progress value
    setProgress(0);

    if(progress > 0 && progress < 100 ){
      setIsLoadReady(2);
    }

    if(!deleteClick){
      setDefaultFilePath(localStorage.getItem('defaultFilePath'));
      setDefaultData(JSON.parse(localStorage.getItem('defaultData')));
    }
  }

  const handleClose = () => setOpen(false);

  // @ TEST 250213 : retune load update
  // update 250325, retune load update : to prevent data save error, need to use delay function
  const delay = async (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleLoadClick = async () => {
    // update 250325, retune load update
    setloadResultTagData({});
    setDisplayLoadResultTag([]);

    if(typeof loadObject !== 'undefined' && loadFilePath !== ''){
      // @ TEST 250213 : retune load update
      // @ retune load before
      // await autoRetuneSave(); // save file before load parameters
      // await delay(500); // to run save click, have to use delay function
      setLoadObjectToSend([]);
      setButtonClickType({...buttonClickType, ['buttonClick']: 'Retune Load'});
    }
  };

  // @ TEST 250213 : retune load update
  // update 250325, retune load update for handle data change normal function to async function
  const handleSaveClick = async () => {
    return new Promise((resolve) => {
      setIsAfterLoad(true);
      setIsSaveReady(2);
      setIsCsvDone(false);
      setButtonClickType({ ...buttonClickType, ['buttonClick']: 'Retune Save PSM4' });
      resolve();
    });
  };

  // TODO : 30개씩 retune해서 30개 단위 벗어나는 경우 autoCompare에서 내부 변수 저장이 조금 빨라서 뒤의 것들은 안되는 현상 있음 -> server에서 고치거나,, 여기서 이렇게 처리하거나
  // TODO : load parameters without auto save parameters
  // update 250325, retune load update : sometimes autoRetuneSave function run little earlier, to fix that need delay function
  const autoRetuneSave = async () => {
    // await delay(2100);     // wait 1 retune cycle
    return new Promise(async (resolve) => {
      setIsSaveReady(2);
      setIsCsvDone(true); // update 250404 // update 250415, retune load 후 save 삭제 - test retune save without download
      await delay(600);
      setButtonClickType({ ...buttonClickType, ['buttonClick']: 'Check Load Result' });

      resolve();
    });
  }

  // [UPDATE] 260513, filter out tags that should be excluded from processing
  const shouldExcludeTag = (tagName) => {
    return tagName.endsWith('_APPLY') && tagName.includes('_CONFIG_');
  }

  // update 250325, retune load update : find different value (compare retune load file to load result file)
  // update 250806, retune load result : compares values up to 6 decimal places
  const findDifference = (obj1, obj2) => {

    const diffrentValue = {};
    // [UPDATE] 260513, remove keys ending with '_APPLY' from the result
    const allObj = _.union(Object.keys(obj1), Object.keys(obj2))
        .filter(key => !shouldExcludeTag(key));


    for(let key of allObj) {
      if((obj1[key] !== null && obj2[key] !== null) && (typeof obj1[key]=== "number" && typeof obj2[key] === "number")){
        const isEqual = !_.isEqual(obj1[key], obj2[key]);
        const isToFixedEqual = parseFloat(obj1[key].toFixed(6)) !== parseFloat(obj2[key].toFixed(6));
        const isTruncatedEqual = truncateToSixDecimals(obj1[key]) !== truncateToSixDecimals(obj2[key]);

        if(isEqual && isToFixedEqual && isTruncatedEqual){
          diffrentValue[key] = obj1[key]; // load를 시도한 값으로 저장해야함
          // to display current value, make displayloadresult tag object
          if(typeof obj1[key] !== 'undefined' ){
            let temp = {'name' : key, 'retune' : obj1[key], 'current' : obj2[key]}
            DisplayLoadResultTag.push(temp);
          }
        }
      }
    }

    for(let key in diffrentValue){
      if(diffrentValue[key] === undefined){
        delete diffrentValue[key]
      }
    }

    return diffrentValue;
  }

  // update 250806, retune load result : compares values up to 6 decimal places
  const truncateToSixDecimals = (num) => {
    return Math.floor(num * Math.pow(10, 6)) / Math.pow(10, 6);
  }

  // update 250325, retune load update : compare data (load parameter, after load parameter)
  const autoCompare  = (before, after) => {

    let resultObj = {};

    if((before && Object.values(before).length > 0) && (after && Object.values(after).length > 0)){
      resultObj = findDifference(before, after); // resultObj : need to re-load

      // for re-load data
      if(Object.keys(resultObj).length !== 0){

        setAutoLoadStatus(1); // autoLoadStatus : loading...

        setloadTagData({});
        setloadResultTagData({});
        setLoadObjectToSend([]);
        setReloadTagData(resultObj); // update 250228

      }else{ // load complete
        setAutoLoadStatus(2);
        setloadTagData({});
        setloadResultTagData({});
        setLoadObjectToSend([]);
        setDisplayLoadResultTag([]);
      }
    }
  }

  const handleSaveFilePathChange = (e, {value}) => {
    setSaveFilePath(value);
  };

  const handleChangePrefixClick = () => {
    // setSelectedPrefix(value);
    // TODO : file 이름 변경
    // TODO : load parameteres 클릭 시, 읽은 csv 파일의 prefix modifyprefix로 변경해야함
    setIsPrefixChanged(true);

    setloadResultTagData({});
    setDisplayLoadResultTag([]);
    setLoadObjectToSend([]);
    setButtonClickType({...buttonClickType, ['buttonClick']: 'Retune Load'});
  }

  const validateLoadFile = (file, currentPLC) => {
    if (file !== null && file !== undefined){
      let splitFileName = file.name.split('_')[1];
      let filePrefix = splitFileName.includes('PSM') ? splitFileName : '';

      if(filePrefix.length !== 0 && filePrefix !== ''){
        if(filePrefix === currentPLC){
          // 유효한 prefix
          setLoadFileErr(0);
        }else{
          // 다른 psm 파일
          setLoadFileErr(2);
          setIsLoadReady(0);
          // TODO : change file name
        }
      }else{
        // 유효하지 않은 파일 이름
        setLoadFileErr(1);
        setIsLoadReady(0);
      }
    }
  }

  const handleLoadPathChange = (e, {value}) => {

    setProgress(0);
    setAutoLoadStatus(0);

    if(value.length===0){
      setProgress(0);
    }else if(isLoadReady !== 2 || isLoadReady === 3){
      setProgress(0);
    }

    setLoadFilePath(value);
    setLoadObject(e.target.files[0]);
    setIsLoadReady(1);

    // update 250131, send load file name to log
    // @ TEST : TODO BUGFIX 2025
    // e.target.files[0] ?? setLoadFileName(e.target.files[0].name);

    const fileList = e.target.files;
    const file = e.target.files[0];

    if(file !== '' && file !== undefined && Object.keys(fileList).length > 0){
      validateLoadFile(file, currentPLC);
    }

    // // update 240516 , check Load File name
    // if(e.target.files[0] !== '' && e.target.files[0] !== 'undefined' && Object.keys(e.target.files).length > 0 ){

    //     let splitTemp = e.target.files[0].name.split('_')[1];
    //     loadFilePPC = splitTemp.includes('PSM') || splitTemp.includes('MAIN') ? splitTemp : '';

    //     if(loadFilePPC.length !== 0 && loadFilePPC !== ''){
    //         if(loadFilePPC === currentPLC){
    //             setLoadFileErr(false);
    //         }else{
    //             setLoadFileErr(true);
    //             setIsLoadReady(0);
    //         }
    //     }else{
    //         setLoadFileErr(true);
    //         setIsLoadReady(0);
    //     }
    // }

    if(Object.keys(e.target.files).length === 0){
      setLoadFileErr(1);
      setIsLoadReady(0);
    }
  };

  // @ TEST : retune progress bar
  const handleCompareFilePathChange = (e,{value}) => {
    setCompareFilePath(value);

    if(e.target.files[0]){
      fileReader.onload = (event) => {
        const text = event.target.result;
        setCompareData(csvToObj(text));
      };
      fileReader.readAsText(e.target.files[0]);
    }
  }

  const handleDefaultFilePathChange = (e, {value}) => {
    // update, save file to local storage ?
    if(defaultFilePath){
      setDefaultFilePath(localStorage.getItem('defaultFilePath'));
    }else{
      setDefaultFilePath(value);
    }

    if(e.target.files[0] && !defaultData){
      defaultFileReader.onload = (event) => {
        const text1 = event.target.result;
        setDefaultData(csvToObj(text1));
      };
      defaultFileReader.readAsText(e.target.files[0]);
    }
  }

  const handleCompareClick = (e) => {
    localStorage.setItem('defaultFilePath', defaultFilePath);
    const savedData = localStorage.getItem('defaultData');

    if(savedData===null){
      localStorage.setItem('defaultData', JSON.stringify(defaultData));
    }else{
      setDefaultData(JSON.parse(savedData));
    }

    // update SOFC, bugfix : check defaultFilePath & compareFilePath's type 240320
    if(defaultFilePath !== 'undefined' && defaultFilePath !== null && compareFilePath !== 'undefined' && compareFilePath !== null){
      if(defaultFilePath.length === 0 || compareFilePath.length === 0 ){
        setSecondModalOpen(false);
      }else{
        getCompareResult(compareData, defaultData);
        setSecondModalOpen(true);
      }
    }
  }

  const csvToObj = (file) => {
    const resArray = [];

    //특수문자 제거
    if(file.includes('KEP') || file.includes('"') || file.includes('\r')){
      file = file.replace(/KEP\\|\"|\r/g, '');
    }

    const csvRows = file.slice(file.indexOf("\n") + 1).split("\n"); // ['KEP\\AL_110ClogBL_Comp,1,Non Standard\r']

    for(let i =0; i < csvRows.length; i++){
      let convertArray = [];
      let convertObj = {};

      convertArray = csvRows[i].split(",");                          // ['AL_110ClogBL_Comp', '1', 'Non Standard\r']
      convertObj[convertArray[0]] = convertArray[1];

      resArray.push(convertObj);
    }
    return resArray;
  }

  const getCompareResult = (obj1, defaultObj) => {
    var diffResult = [];
    // var diff = [];
    if(defaultObj && defaultObj.length > 0){
      for(let i = 0; i < defaultObj.length; i++){
        diffResult[i] = {
          'name' : Object.keys(defaultObj[i]).toString(),
          'value' : Number(Object.values(defaultObj[i])),
          'diffValue' : ''
        }
        for(let j =0; j < obj1.length; j++){
          if(Object.keys(defaultObj[i]).toString().toUpperCase() === Object.keys(obj1[j]).toString().toUpperCase() && Number(Object.values(defaultObj[i])) !== Number(Object.values(obj1[j]))){
            // diff.push({[Object.keys(obj1[j]).toString()] : Number(Object.values(obj1[j]))});
            diffResult[i].diffValue = Number(Object.values(obj1[j]));
          }
          continue;
        }
      }
    }

    setResultData(diffResult);
    setDiffData(diffResult.filter(c => c.diffValue !== ''));

    return diffResult;
  }

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  }

  const handleDeleteDefaultFileClick = (e) => {
    e.preventDefault();
    localStorage.clear();
    setDefaultFilePath('');
    setDefaultData('');
  }

  const gridCompareTitle = () => {
    return (
        <Grid.Row>
          <Grid.Column width = {6}>
            <p style={{fontSize : '13px', fontWeight:'bold'}}>Tag Name</p>
          </Grid.Column>
          <Grid.Column width = {3}>
            <p style={{fontSize : '13px', fontWeight:'bold'}}>Default Value</p>
          </Grid.Column>
          <Grid.Column width = {3}>
            <p style={{fontSize : '13px', fontWeight:'bold'}}>Compare Value</p>
          </Grid.Column>
        </Grid.Row>
    )
  }

  const gridRetuneResultTitle = () => {
    return (
        <Grid.Row style={{marginBottom : '0px', paddingBottom : '2px', paddingTop : '3px'}}>
          <Grid.Column width = {10}>
            <p style={{fontSize : '13px', fontWeight:'bold', color : 'black'}}>Tag Name</p>
          </Grid.Column>
          <Grid.Column width = {3}>
            <p style={{fontSize : '13px', fontWeight:'bold', color : 'black'}}>Retune Value</p>
          </Grid.Column>
          <Grid.Column width = {3}>
            <p style={{fontSize : '13px', fontWeight:'bold', color : 'black'}}>Current Value</p>
          </Grid.Column>
        </Grid.Row>
    )
  }

  // update 250325, retune laod update : display load - compare status
  const displayLoadCompareStatus = (status) => {
    if (status === 0){
      return 'ready'; // initial -> ready
    }else if (status === 1){
      return 'Load Fail...';
    }else if (status === 2){
      return 'load complete!';
    }else if (status === 3){
      return 'loading... ';
    }
  }

  // update 250325, retune load update : re-load click
  const handleLoadRetryClick = () => {
    setDisplayLoadResultTag([]);
    autoLoadupdateData(reloadTagData);
  }

  return (
      <div>
        <h1 style={{textAlign : 'center'}}>Retune (PSM4)</h1>
        <Modal trigger = {<Button color = 'blue'>RETUNE_PSM4</Button>}
               style = {(autoLoadStatus === 1) ? {width : '800px'} : {width : '600px'}}
               open = {open}
               closeOnDimmerClick={false}
               onClose={handleClose}
               onOpen={handleOpen}
        >
          <Modal.Header>RETUNE (PSM4)</Modal.Header>

          <Modal.Content scrolling >
            <Form>
              <Form.Group widths='equal'>
                <Form.Field>

                  {/* <Label horizontal basic
                                       size='small'
                                       style={styles.label}
                                       content={(isReady === 0) ? 'Not Ready' : (isReady === 1) ? 'Ready' : 'Loading... Please Wait'}
                                       color={(isReady === 0) ? 'red' : (isReady === 1) ? 'green' : 'blue'}
                                /> */}

                  <Label horizontal basic
                         size='small'
                         style={styles.label}
                         content={(isSaveReady === 0) ? 'Save : Ready' : (isSaveReady === 1) ? 'Save : Saving...' : 'Save : Complete'}
                         color={(isSaveReady === 0) ? 'green' : (isSaveReady === 1) ? 'green' : 'blue'}
                  />

                  <Label horizontal basic
                         size='small'
                         style={styles.label}
                         content={(isLoadReady === 0) ? 'Load Progress : Not Ready' : (isLoadReady === 1) ? 'Load Progress : Ready' : (isLoadReady === 2) ? 'Load Progress : Loading... Please Wait' : 'Load Progress : Complete'}
                         color={(isLoadReady === 0) ? 'red' : (isLoadReady === 1 || isLoadReady === 2) ? 'green' : 'blue'}
                  />

                  <Label horizontal basic
                         size='small'
                         style={styles.label}
                         color={(autoLoadStatus === 1) ? 'red' : autoLoadStatus === 2 ? 'blue' : 'black'}
                  >
                    Load Retry : {displayLoadCompareStatus(autoLoadStatus)}
                  </Label>
                </Form.Field>
              </Form.Group>
              <Progress percent={progress} progress />

              <Form.Group widths='equal'>
                <Form.Input
                    label='Read From File (Load Only)'
                    id='read_from_file'
                    name='read_from_file'
                    type='file'
                    accept='.csv'
                    size='small'
                    value={loadFilePath}
                    onChange={handleLoadPathChange}
                    error={ loadFileErr !== 0 && ERROR_MESSAGES[loadFileErr] && {content : ERROR_MESSAGES[loadFileErr]}} // update 240516, dipslay file name error
                />
              </Form.Group>

              { loadFileErr === 2 &&
                  <>
                    <Button
                        basic
                        color='red'
                        content='Change Prefix & Load Parameters'
                        onClick={handleChangePrefixClick}
                        style={{marginTop : '0px', marginBottom : '5px'}}
                    />
                  </>
              }

              <Form.Group widths='equal'>
                <Form.Input
                    label='Write To File (Save Only)'
                    id='write_to_file'
                    name='write_to_file'
                    size='small'
                    value={saveFilePath}
                    onChange={handleSaveFilePathChange}
                />
              </Form.Group>

              <Form.Group grouped width='equals'>
                <label style={{color : 'black'}}>Compare File (Compare Only)</label>
                <br />

                { defaultFilePath ?
                    <div>
                      <Label content='Default Retune File :' style={{marginRight : '10px', marginBottom : '0px', marginTop : '10px'}} basic>
                        Default retune file :
                        <span style={{fontWeight : 'normal'}}>
                                            &nbsp; {defaultFilePath.includes('C:\\fakepath\\')? defaultFilePath.replace('C:\\fakepath\\', '') : defaultFilePath}
                                        </span>
                      </Label>
                      <Button
                          size='mini'
                          content='Delete File'
                          onClick={handleDeleteDefaultFileClick}/>

                    </div>
                    :
                    <div>
                      <Label content='Default Retune File' style={{marginRight : '10px', marginBottom : '0px', marginTop : '10px'}} />
                      <Form.Input
                          id='default_file'
                          name='default_file'
                          type='file'
                          accept='.csv'
                          size='small'
                          value={defaultFilePath}
                          onChange={handleDefaultFilePathChange}
                          readOnly
                          style={{marginTop : '0px'}}
                      />
                    </div>
                }

                <Label content='File to Compare' style={{marginRight : '10px', marginBottom : '0px', marginTop : '10px'}} />
                <Form.Input
                    id='compare_file'
                    name='compare_file'
                    type='file'
                    accept='.csv'
                    size='small'
                    value={compareFilePath}
                    onChange={handleCompareFilePathChange}
                />
              </Form.Group>

              <div>
                <Header size = 'small' style={{marginBottom:'3px', marginTop : '30px'}}> Retune Load Result</Header>
                <Label basic color={autoLoadStatus === 1 ? 'red' : autoLoadStatus === 2 ? 'blue' : 'black'}> Load Result : {displayLoadCompareStatus(autoLoadStatus)} </Label>
                <Button
                    color = {'orange'}
                    size = {'small'}
                    content = 'Load Retry'
                    onClick = {handleLoadRetryClick}
                    disabled = {autoLoadStatus !== 1 }
                    style={{marginLeft : '10px'}}
                />

                {autoLoadStatus === 1 &&
                    <>
                      <p style={{color : 'black', marginLeft : '5px', marginTop : '5px', marginBottom : '15px'}}>Fail total : {Object.values(reloadTagData).length}</p>

                      <Grid style={{marginLeft : '10px'}}>
                        {gridRetuneResultTitle()}
                        <Grid.Row >
                          {DisplayLoadResultTag.map((c,i) => {
                            return (
                                <>
                                  <Grid.Column width={10} style={{wordWrap : 'breakWord'}}>
                                    <span style={{color : 'black'}}>{DisplayLoadResultTag[i].name}</span>
                                  </Grid.Column>
                                  <Grid.Column width={3} style={{textAlign : 'center'}}>
                                    <span style={{color : 'black'}}>{JSON.stringify(DisplayLoadResultTag[i].retune)}</span>
                                  </Grid.Column>
                                  <Grid.Column width={3} style={{textAlign : 'center'}}>
                                    <span style={{color : 'black'}}>{JSON.stringify(DisplayLoadResultTag[i].current)}</span>
                                  </Grid.Column>
                                </>
                            )
                          })}
                        </Grid.Row>
                      </Grid>
                    </>
                }
              </div>
            </Form>
          </Modal.Content>

          <Modal.Actions style = {{marginLeft: '10px'}}>
            <Button color={'red'}
                    size='small'
                    id = '1'
                    content='Exit'
                    onClick={handleClose}
            />
            <Button color={'blue'}
                    size='small'
                    id = '2'
                    content='Load Parameters'
                    onClick={handleLoadClick}
                    disabled={loadFileErr !== 0}
            />
            <Button color={'blue'}
                    size='small'
                    id = '3'
                    content='Save Parameters'
                    onClick={handleSaveClick}
            />
            <Button color={'grey'}
                    size='small'
                    id = '4'
                    content='Compare'
                    onClick={handleCompareClick}
                    icon='right chevron'
                    labelPosition='right'
            />
          </Modal.Actions>

          {/** Retune Compare modal  */}
          <Modal
              onClose = {() => setSecondModalOpen(false)}
              onOpen={() => setSecondModalOpen(true)}
              open={secondModalOpen}
              size='small'
          >
            <Modal.Header>Compare</Modal.Header>
            <Form>
              <Checkbox
                  label='See All'
                  style= {{ float : 'right', marginRight : '20px', marginTop : '10px' }}
                  id='checkbox'
                  name='checkbox'
                  checked= {checked}
                  onChange= {handleCheckboxChange}
              />
            </Form>
            <p style={{color : 'black', float : 'left', marginLeft : '20px', marginTop : '10px'}}>
              Total : {checked === false && resultData.length > 0 ?
                diffData.length > 0 && diffData.length : Object.keys(resultData).length } </p>

            <Modal.Content style={{color : 'black'}} scrolling>
              { !checked && diffData.length > 0 ?
                  <Grid>
                    {gridCompareTitle()}
                    <Grid.Row>
                      {diffData.map((c,i) => {
                        return (
                            <>
                              <Grid.Column width={6} style={{wordWrap : 'breakWord'}}>
                                <span>{JSON.stringify(diffData[i].name).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                              <Grid.Column width={3} style={{textAlign : 'center'}}>
                                <span>{JSON.stringify(diffData[i].value).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                              <Grid.Column width={3} style={{textAlign : 'center'}}>
                                <span>{JSON.stringify(diffData[i].diffValue).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                            </>
                        )
                      })}
                    </Grid.Row>
                  </Grid>
                  :
                  <Grid>
                    {gridCompareTitle()}
                    <Grid.Row>
                      {resultData.length > 0 && resultData.map((c, i) => {
                        return (
                            <>
                              <Grid.Column width={6} style={{wordWrap : 'breakWord'}}>
                                <span>{JSON.stringify(resultData[i].name).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                              <Grid.Column width={3} style={{textAlign : 'center'}}>
                                <span>{JSON.stringify(resultData[i].value).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                              <Grid.Column width={3} style={{textAlign : 'center'}}>
                                <span>{JSON.stringify(resultData[i].diffValue).replace(/({|}|"|\[|\])|/g, '')}</span>
                              </Grid.Column>
                            </>
                        )
                      })}
                    </Grid.Row>
                  </Grid>

              }

            </Modal.Content>
            <Modal.Actions style = {{marginLeft: '10px'}}>
              <Button color={'red'}
                      size='small'
                      id = '1'
                      content='Exit'
                      onClick={() => setSecondModalOpen(false)}
              />
            </Modal.Actions>
          </Modal>

        </Modal>
      </div>
  );
};

const styles = {
  label: {
    float: 'right',
    textAlign: 'center'
  },
  toggle: {
    marginLeft: '8px'
  },
  header: {
    marginBottom: '15px'
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPPID: (ppid) => dispatch(setPPID(ppid))
  };
};

const mapStateToProps = (state) => {
  return {
    ppid: state.header.ppid
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Retune_PSM4);